// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class MedicalBiQuantityLimit {
    'quantityLimit'?: string;
    'obtainExceptionPhone'?: string;
    'obtainExceptionProcess'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof MedicalBiQuantityLimit>> = [
        {
            "name":     "quantityLimit",
            "baseName": "quantityLimit",
            "type":     "string"
        },
        {
            "name":     "obtainExceptionPhone",
            "baseName": "obtainExceptionPhone",
            "type":     "string"
        },
        {
            "name":     "obtainExceptionProcess",
            "baseName": "obtainExceptionProcess",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return MedicalBiQuantityLimit.attributeTypeMap;
    }
}
